import { render } from "./bidMore.vue?vue&type=template&id=e4bbdaba"
import script from "./bidMore.vue?vue&type=script&lang=js"
export * from "./bidMore.vue?vue&type=script&lang=js"

import "./bidMore.vue?vue&type=style&index=0&id=e4bbdaba&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__